import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LocalStorageService } from './local-storage.service';
import { Order } from '../../models/order';

@Injectable({
  providedIn: 'root'
})
export class PurchaseSuccessService {
  private apiUrl = environment.API_BACKEND;

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService
  ) {}

  /**
   * Buscar dados da compra mais recente
   */
  getLatestPurchase(): Observable<Order> {
    const headers = this.getAuthHeaders();
    return this.http.get<Order>(`${this.apiUrl}/orders/latest`, { headers });
  }

  /**
   * Buscar dados de uma compra específica por ID
   */
  getPurchaseById(orderId: number): Observable<Order> {
    const headers = this.getAuthHeaders();
    return this.http.get<Order>(`${this.apiUrl}/orders/${orderId}`, { headers });
  }

  /**
   * Buscar dados do carrinho atual (para casos onde ainda não foi convertido em pedido)
   */
  getCurrentCart(): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get(`${this.apiUrl}/cart`, { headers });
  }

  private getAuthHeaders(): HttpHeaders {
    const token = this.localStorageService.getItem("auth-token");
    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
  }
}
